module.exports = {
      id: "comm-children-usage",
      viewBox: "0 0 237.872 42.449",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-children",
      toString: function () {
        return this.url;
      }
    }